module.exports = __webpack_public_path__ + "static/media/20160201_191628.7e657ab3.jpg";